import i18n from '@/i18n'
import { mcToast } from '@/plugins/McToastAlertPlugin'

export const state = {
  activePopups: [],
}

export const mutations = {
  ADD_POPUP(state, popup) {
    state.activePopups.push(popup)
    localStorage.setItem('ctPopups', JSON.stringify(state.activePopups))
  },
  REMOVE_POPUP(state, vehicleId) {
    const index = state.activePopups.findIndex((popup) => popup.id === vehicleId)
    if (index !== -1) {
      state.activePopups.splice(index, 1)
      localStorage.setItem('ctPopups', JSON.stringify(state.activePopups))
    }
  },
  LOAD_POPUPS(state, popups) {
    state.activePopups = popups
  },
}

export const actions = {
  addPopup({ commit, state }, { ctData }) {
    const isExists = state.activePopups.some((popup) => popup.id === ctData.vehicleId)
    if (isExists) return
    if (state.activePopups.length >= 9) {
      mcToast.warning(i18n.t('notification.text.limitNotification'))
      return
    }

    const newPopup = {
      id: ctData.vehicleId,
      data: ctData,
      x: Math.floor(Math.random() * 300),
      y: Math.floor(Math.random() * 300),
    }
    commit('ADD_POPUP', newPopup)
  },
  closePopup({ commit }, vehicleId) {
    commit('REMOVE_POPUP', vehicleId)
  },
}
